export { default } from "./TeacherDetail";

